export default __webpack_public_path__ + "static/media/Background.e1e6fc9f.jpg";